import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { FormProvider } from 'react-hook-form';

function FormsWrapper({ onChange, onSubmit, children, form }) {
  const { handleSubmit, watch, getValues } = form;

  useEffect(() => {
    const subscription = watch((v, args) => {
      onChange(v, args);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    onChange(getValues(), form);
  }, []);

  const submit = (data) => {
    onSubmit(data, form);
  };

  return (
    <FormProvider {...form}>
      <Box component="form" onSubmit={handleSubmit(submit)}>
        {children}
      </Box>
    </FormProvider>
  );
}

FormsWrapper.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  children: PropTypes.node.isRequired,
  resolver: PropTypes.any,
  form: PropTypes.any,
};

FormsWrapper.defaultProps = {
  value: null,
  onChange: () => {},
  onSubmit: () => {},
  resolver: null,
  form: null,
};

export default FormsWrapper;
